import { PiWhatsappLogo } from "react-icons/pi";
import ctaShape from "../images/ctaShape.png";
import { Link } from "react-router-dom";

const CallToActionCard = () => {
    return (
      <section id="CallToActionCard" className='mt-20' style={{backgroundImage:`url(${ctaShape})`}}> 
         <div className='container m-auto w-4/5 py-5'>
          <div className='row grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4 items-center'>
            <div className='ContactText'>
                <h4 className="text-white py-4 text-bold">Looking for the Best Transport Services?</h4>
                <p className="text-white">As a app web crawler expert, We will help to organize.</p>
            </div>
            <div className='ContactBtn text-center m-auto'>
             <button className='CtaBtn flex gap-4 items-center self-center place-content-center'>
<Link
  to="https://wa.me/918989538381?text=Hello%20I%20want%20to%20know%20more%20about%20your%20services"
  target="_blank"
  rel="noopener noreferrer"
  className="flex gap-5 items-center"
>
  <span><PiWhatsappLogo /></span> +918989538381
</Link>

             </button>
            </div>
          </div>
         </div>
      </section>
    )
}
export default CallToActionCard;